import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

import APP_ROUTES from "./routeConstants";

import Dashboard from "../pages/Dashboard";
import Layout from "../shared/Layout";
import Player from "../pages/Player";
import Coach from "../pages/Coach";
import Agent from "../pages/Agent";
import Scout from "../pages/Scout";
import Others from "../pages/Others";
import NotFound from "../pages/NotFound";
import ProtectedRoutes from "./ProtectedRoute";
import Network from "../pages/Network";
import GoStar from "../pages/GoStar";
import Explore from "../pages/Explore";
import Search from "../pages/Search";
import CreateEventSteps from "../pages/Events/CreateEventSteps";
import EventCreated from "../pages/Events/EventCreated";
import EventsList from "../pages/Events/EventsList";
import EventDetails from "../pages/Events/EventDetails";
import CreateGroup from "../pages/Entity/Components/Groups/CreateGroup";
import GroupDetails from "../pages/Entity/Components/Groups/GroupDetails";
import MainLoader from "../shared/MainLoader";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Entity from "../pages/Entity";
import ChatContainer from "../pages/Chat";
import CreateEvent from "../pages/Events/CreateEvents";
import InviteParticipants from "../pages/Events/EventDetails/InviteParticipants";
import PaymentOverview from "../pages/Payment/PaymentOverview";
import HowItWorks from "../pages/Payment/CreatePaymentLink/HowItWorks";
import CreatePaymentLink from "../pages/Payment/CreatePaymentLink/CreatePaymentLink/CreatePaymentLink";
import CreatePaymentAccount from "../pages/Payment/CreatePaymentAccount";
import CreatePaymentLinks from "../pages/Payment/PaymentLinks";
import NetworkError from "../pages/NetworkError";
import { useEffect } from "react";
import { setNavigate } from "./routeUtils";

const AppRouter = ({ user, isLoading, isTokenLoaded }: { user: any; isLoading: boolean; isTokenLoaded: boolean }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  if (isLoading && !isTokenLoaded) {
    return <MainLoader />;
  }

  return (
    <Routes>
      <Route path={APP_ROUTES.HOME} element={user ? <Navigate to={APP_ROUTES.DASHBOARD} /> : <Home />} />
      <Route path={APP_ROUTES.LOGIN} element={user ? <Navigate to={APP_ROUTES.DASHBOARD} /> : <Login />} />

      <Route element={<ProtectedRoutes isTokenLoaded={isTokenLoaded} />}>
        <Route element={<Layout />}>
          <Route path={APP_ROUTES.DASHBOARD} element={<Dashboard />} />
          <Route path={APP_ROUTES.NETWORK} element={<Network />} />
          <Route path={APP_ROUTES.EXPLORE} element={<Explore />} />
          <Route path={APP_ROUTES.ENTITY} element={<Entity />} />
          <Route path={APP_ROUTES.ENTITY_DETAILS} element={<Entity />} />
          <Route path={APP_ROUTES.CREATE_GROUP} element={<CreateGroup />} />
          <Route path={APP_ROUTES.GROUP_DETAILS} element={<GroupDetails />} />
          <Route path={APP_ROUTES.PLAYER} element={<Player />} />
          <Route path={APP_ROUTES.COACH} element={<Coach />} />
          <Route path={APP_ROUTES.AGENT} element={<Agent />} />
          <Route path={APP_ROUTES.SCOUT} element={<Scout />} />
          <Route path={APP_ROUTES.OTHER_PROFILE} element={<Others />} />
          <Route path={APP_ROUTES.GO_STAR} element={<GoStar />} />
          <Route path={APP_ROUTES.GO_STAR_QUERY} element={<GoStar />} />
          <Route path={APP_ROUTES.SEARCH} element={<Search />} />
          <Route path={APP_ROUTES.CHAT} element={<ChatContainer />} />
          <Route path={APP_ROUTES.CHAT_DETAILS} element={<ChatContainer />} />
          <Route path={APP_ROUTES.EVENTS} element={<EventsList />} />
          <Route path={APP_ROUTES.CREATE_EVENT} element={<CreateEvent />} />
          <Route path={APP_ROUTES.CREATE_EVENT_STEPS} element={<CreateEventSteps />} />
          <Route path={APP_ROUTES.EVENT_CREATED} element={<EventCreated />} />
          <Route path={APP_ROUTES.EVENT_DETAILS} element={<EventDetails />} />
          <Route path={APP_ROUTES.INVITE_PARTICIPANTS} element={<InviteParticipants />} />
          {/* <Route path={APP_ROUTES.PAYMENT} element={<PaymentOverview />} />
          <Route path={APP_ROUTES.PAYMENT_HOW_IT_WORKS} element={<HowItWorks />} />
          <Route path={APP_ROUTES.CREATE_PAYMENT_LINK} element={<CreatePaymentLink />} />
          <Route path={APP_ROUTES.CREATE_PAYMENT_ACCOUNT} element={<CreatePaymentAccount />} /> */}
        </Route>
      </Route>
      <Route path={APP_ROUTES.NOT_FOUND} element={<NotFound />} />
      <Route path={APP_ROUTES.CATCH} element={<NotFound />} />
      <Route path={APP_ROUTES.NETWORK_ERROR} element={<NetworkError />} />
    </Routes>
  );
};

export default AppRouter;
